<template>
<v-btn-toggle v-model="userTemperatureUnit" color="secondary" mandatory rounded class="mx-3">
  <v-btn text small value="C"> {{ $t(`unit.C`) }} </v-btn>
  <v-btn text small value="F">{{ $t(`unit.F`) }} </v-btn>
</v-btn-toggle>
</template>
<script>
import User from '@/components/auth/User'

export default {
  name: 'TemperatureUnitSelector',
  mixins: [User]
}
</script>
